export default __webpack_public_path__ + "static/media/2.5ea39f78.jpg";